<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="img"><a id="page10"><img alt="image" src="images/p10.jpg"/></a></p><a id="page10">
</a><h1 class="head"><a id="page10"></a><a id="page11"><span class="col1c">Emily</span></a></h1><a id="page11">
<p class="intro_text"><span class="font1">Whenever people say they’re having amazing sex, my first thought is, “Good for you.”</span> My next is, “What does that mean?” Turns out it means something different for everyone. Amazing sex can be about safety, comfort, ecstasy, orgasm, completion, wholeness, or just some good old-fashioned, toe-curling, gasp-inducing fun.</p>
<p class="intro_text">Even the most sexually aware person can occasionally feel that sex has become routine and it’s time to shake things up. The good news is this: you can expand your sexual repertoire with ease. Whether you’ve been curious about having a threesome, thinking of tying up your partner, or just craving some different takes on the missionary position, this book will get you there.</p>
<p class="intro_text">Communication is a kind of lubrication, and talking to your partner about sex is the best way to keep the excitement and increase the intimacy in your relationship. This book will show you ways to explore and expand your sex life, whether it’s a one-night stand or one more night with your lover. These tips work in any bedroom (or backseat) in the world.</p>
<p class="intro_text">Look at these pointers as your erotic road map—or a sexy cookbook full of tantalizing recipes. Read, experiment, and see what works for you.</p>
<p class="intro_text">Remember, you don’t have to try everything (it would be amazing if everyone liked every thing in this book—it’s a sampler, not a rulebook!). Let the tips inspire you as you flip through the pages, with a partner or by yourself. Try one at a time, a position a week, or two tips a month, and we promise it will shake up, enhance, and supercharge your sex life.</p>
<p class="right1">Love,</p>
<p class="right"><img alt="image" src="images/sign1.jpg"/></p>
</a></div><a id="page11">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fmpart4.vue?1ed9b11a